import FilterButtonLayout from "./FilterButtonLayout";
import React, { FC } from "react";

interface FilterButtonsProps {
  isDisplayClearButton?: boolean;
  filterQueryCancelHandler?: any;
  filterQueryHandler: any;
}

const FilterButtons: FC<FilterButtonsProps> = ({
  isDisplayClearButton = false,
  filterQueryCancelHandler,
  filterQueryHandler,
}) => {
  return (
    <React.Fragment>
      {isDisplayClearButton && (
        <FilterButtonLayout>
          <button
            onClick={filterQueryCancelHandler}
            className="btn btn-sm  btn-secondary"
          >
            Clear
          </button>
        </FilterButtonLayout>
      )}
      <FilterButtonLayout>
        <button onClick={filterQueryHandler} className="btn btn-sm btn-primary">
          Go
        </button>
      </FilterButtonLayout>
    </React.Fragment>
  );
};

export default FilterButtons;
